import session from "@/api/session";

export default {
  fetchContracts(id, options) {
    return session.get(`/products/${id}/contracts/`, {
      params: {
        page: options.page,
        limit: options.itemsPerPage,
        order: 'desc'
      }
    });
  },

  fetchContractPDF(id) {
    return session.get(`/contracts/${id}/pdf/`, { responseType: "blob" });
  },

  fetchContractSummaryPDF(id) {
    return session.get(`/contracts/${id}/pdf/summary/`, { responseType: "blob" });
  },

  fetchContractInformationPDF(id) {
    return session.get(`/contracts/${id}/pdf/information/`, { responseType: "blob" });
  }
};